import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=70a2ceb1&"
import script from "./Watermark.vue?vue&type=script&lang=js&"
export * from "./Watermark.vue?vue&type=script&lang=js&"
import style0 from "./Watermark.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports